var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldDisplayNoticeBar)?_c('div',{staticClass:"compass-notice-bar",on:{"click":_vm.navigateToSignatureNotice}},[_c('div',{staticClass:"compass-notice-bar-text"},[_vm._v(" "+_vm._s(_vm.$t("compassNoticeBar.text"))+" ")]),_c('v-icon',{attrs:{"color":"#fff"}},[_vm._v(" mdi-chevron-right ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }